<template>
  <div class="mt-4">
    <v-toolbar flat color="earth">
      <h2 class="title">申請履歴</h2>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="records"
      hide-actions
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left no-wrap">{{ props.item.marginPercent }}</td>
        <td class="text-xs-left no-wrap">{{ props.item.dateRange }}</td>
        <td class="text-xs-left">{{ props.item.statusDisplayName }}</td>
        <td class="text-xs-left">{{ props.item.reason }}</td>
        <td class="text-xs-left">{{ props.item.requestAccountName }}</td>
        <td class="text-xs-left no-wrap">
          {{ props.item.requestTimeToMinites }}
        </td>
        <td class="text-xs-left">
          <v-btn
            v-if="props.item.isCancelable"
            @click="cancelRequest(props.item)"
            small
            color="primary"
            class="mx-0"
          >
            取り消し
          </v-btn>
        </td>
      </template>
      <template slot="no-data">
        <div>申請履歴はありません</div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    records: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headers: [
        { text: 'マージン率', value: 'marginValue' },
        { text: '使用可能期間', value: 'dateRange' },
        { text: 'ステータス', value: 'status' },
        { text: '却下理由', value: 'rejectReason' },
        { text: '申請者', value: 'requestedBy' },
        { text: '申請日時', value: 'requestedAt' },
        { text: '編集/削除', value: 'action' },
      ],
    }
  },
  computed: {},
  methods: {
    cancelRequest(obj) {
      console.log('取り消し')
      console.log(obj)
      this.$emit('cancelRequest', obj)
    },
  },
}
</script>
